<div class="search-bar">
    <div class="search-input-wrapper">
        <input type="text" placeholder="Buscar" [(ngModel)]="searchText" (keyup.enter)="onSearch()" #searchBarInput />
        <div class="clear-icon" *ngIf="searchText" (click)="clearSearch(true)">
            <fa-icon [icon]="faX"></fa-icon>
        </div>
        <div class="search-icon" (click)="onSearch()" [ngClass] = "{'disabled': !searchText}">
            <fa-icon [icon]="faSearch"></fa-icon>
        </div>
    </div>
</div>